import {
  LOAD_MESSAGES,
  MESSAGES_LOADED,
  MESSAGE_DELETED,
  SAVE_MESSAGE,
  MESSAGE_SAVED,
  LOAD_MESSAGE_TYPES,
  MESSAGE_TYPES_LOADED,
  SYNCING,
  SYNC_FAILED,
  CONTROL_MESSAGE_POPUP,
  MESSAGE_ADDED,
  RESET_MESSAGE_ERROR,
} from './actionTypes';

import {
  ISetMessagesAction,
  ISetMessageTypesAction,
  IFailedSyncAction,
  IMessagesAction,
  IMessagesState,
  ISaveMessageAction,
  IPopUpAction,
} from './types';

export const initialState = {
  error: null,
  syncing: false,

  messages: [],
  messagesLoaded: false,

  messageTypes: [],
  messageTypesLoaded: false,

  selectedMessage: null,
  messageLoaded: false,

  messageSaved: false,

  messagePopUpState: false,
  messagesContext: '',
};

export const reducer = (
  state: IMessagesState = initialState,
  action: IMessagesAction
): IMessagesState => {
  const defaultSuccess = { error: null, syncing: true };
  const defaultSuccessDone = { error: null, syncing: false };

  switch (action.type) {
    case LOAD_MESSAGES:
      return { ...state, ...defaultSuccess, messagesLoaded: false };
    case MESSAGES_LOADED:
      return {
        ...state,
        ...defaultSuccessDone,
        messagesLoaded: true,
        messages: (action as ISetMessagesAction).payload.data,
        messagesContext: (action as ISetMessagesAction).payload.context,
      };

    case SYNCING:
      return { ...state, ...defaultSuccess };
    case MESSAGE_DELETED:
      const newMessages = state.messages.filter((item) => {
        return item.name !== action.payload;
      });
      return {
        ...state,
        ...defaultSuccessDone,
        messages: newMessages,
      };

    case SAVE_MESSAGE:
      return { ...state, ...defaultSuccess, messageSaved: false };
    case MESSAGE_SAVED:
      return { ...state, ...defaultSuccessDone, messageSaved: true };

    case LOAD_MESSAGE_TYPES:
      return { ...state, ...defaultSuccess, messageTypesLoaded: false };
    case MESSAGE_TYPES_LOADED:
      return {
        ...state,
        ...defaultSuccessDone,
        messageTypes: (action as ISetMessageTypesAction).payload.map((option) => ({
          value: option,
          label: option,
        })),
        messageTypesLoaded: true,
      };

    case SYNC_FAILED:
      return { ...state, error: (action as IFailedSyncAction).payload, syncing: false };

    case CONTROL_MESSAGE_POPUP:
      return {
        ...state,
        messagePopUpState: (action as IPopUpAction).payload,
      };
    case RESET_MESSAGE_ERROR:
      return {
        ...state,
        error: null,
      };
    case MESSAGE_ADDED:
      const messageExists = state.messages.find(
        (message) => message.name === (action as ISaveMessageAction).payload.name
      );
      if (messageExists) {
        return {
          ...state,
          messages: state.messages.map((el) =>
            el.id === (action as ISaveMessageAction).payload.id
              ? (action as ISaveMessageAction).payload
              : el
          ),
          syncing: false,
          messageSaved: !state.messageSaved,
        };
      }
      return {
        ...state,
        messages: [...state.messages, (action as ISaveMessageAction).payload],
        syncing: false,
        messageSaved: !state.messageSaved,
      };

    default:
      return state;
  }
};
